<template>
  <div class="card-container">
    <div v-if="showChart" class="chart-info">
      <div class="title">
        {{ $t('quote.brief.funds-change') }}
      </div>
      <div class="title subtitle">
        {{ $t('quote.brief.five-day-change') + ` ${unit}` }}
      </div>
      <div class="legend-container">
        <div class="legend-key">
          <div class="color-box funds-in" />
          <div class="label-text">
            {{ $t('quote.brief.funds-in') }}
          </div>
        </div>
        <div class="legend-key">
          <div class="color-box funds-out" />
          <div class="label-text">
            {{ $t('quote.brief.funds-out') }}
          </div>
        </div>
      </div>
      <EChart class="chart" :options="chartOptions" :width="280" />
    </div>
    <div v-else class="financial-info-empty">
      <div class="title">
        {{ $t('quote.brief.funds-change') }}
      </div>
      <div class="no-data">
        {{ $t('quote.no-data') }}
      </div>
    </div>
  </div>
</template>
<script>
import EChart from 'com/EChart'
import themeMixin from './theme-mixin'

export default {
  name: 'FiveDayOrders',
  props: {
    unit: String,
    chartData: Array,
    isRedUp: Boolean
  },
  components: {
    EChart
  },
  mixins: [themeMixin],
  computed: {
    showChart() {
      if (!this.chartData) return false
      return this.chartData.length > 0
    },
    chartOptions() {
      if (!this.chartData) return {}
      const options = {
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#838D9E'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          show: false
        },
        grid: {
          show: false
        },
        series: [
          {
            name: '0',
            type: 'bar',
            barMaxWidth: 35,
            label: {
              normal: {
                show: true,
                position: 'top',
                rotate: 45,
                offset: [10, -15],
                textStyle: {
                  color: this.curTheme[this.theme].fontColor
                }
              }
            }
          }
        ]
      }

      // X Axis Labels
      options.xAxis.data = this.chartData.map(item => {
        const valObject = {
          value: item.date,
          textStyle: {
            fontWeight: 'bold'
          }
        }
        return valObject
      })
      // Bar Values
      options.series[0].data = this.chartData.map(item => {
        const valObject = {
          value: parseFloat(item.change).toFixed(0),
          itemStyle: {
            normal: {
              color: this.getBarColor(item.change)
            }
          },
          label: {
            normal: {
              formatter(params) {
                const val = params.value
                return val > 0 ? `+${val}` : val
              }
            }
          }
        }
        return valObject
      })
      return options
    }
  },
  methods: {
    getBarColor(value) {
      const green = this.curTheme[this.theme].green
      const red = this.curTheme[this.theme].red
      if (parseFloat(value) > 0) {
        return this.isRedUp ? red : green
      } else {
        return this.isRedUp ? green : red
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';

.card-container {
  .title {
    color: var(--default-font-color);
    font-size: 12px;
    margin-bottom: 8px;
  }
  .legend-container {
    display: flex;
    justify-content: center;
    .legend-key {
      display: flex;
      justify-content: center;
      align-items: center;
      &:nth-child(1) {
        margin-right: 10px;
      }
      .color-box {
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        margin-right: 5px;
        background: transparent;
      }
    }
  }
  .chart {
    margin: 0 auto;
  }
}
.funds-in {
  border: solid 2.5px var(--green);
}
.funds-out {
  border: solid 2.5px var(--red);
}
.stock-color--red-up {
  .funds-in {
    border-color: var(--red) !important;
  }
  .funds-out {
    border-color: var(--green) !important;
  }
}
.no-data {
  width: 100%;
  display: inline-block;
  margin: 20px auto;
  text-align: center;
}
</style>
